import { css } from '@emotion/react';
import { responsiveStyles } from '@polestar/component-warehouse-react/helpers/responsiveStyle';
import styled from '@emotion/styled';
import AspectRatios from '@polestar/component-warehouse-react/tokens/aspect-ratios/AspectRatios';
import React, { forwardRef } from 'react';
const AspectRatio = forwardRef(({ ratio = AspectRatios.square, children, ...props }, ref) => {
    return (React.createElement(Container, { ...props, ref: ref, ratio: ratio },
        React.createElement(Inner, null, children)));
});
AspectRatio.displayName = 'AspectRatio';
export default AspectRatio;
const Container = styled.div(({ ratio }) => css(css `
      position: relative;
      width: 100%;
      height: 0;
    `, typeof ratio === 'number' &&
    css `
        padding-block-start: ${100 / ratio}%;
      `, typeof ratio !== 'number' &&
    responsiveStyles({ paddingBlockStart: ratio }, {
        paddingBlockStart: (value) => 100 / value + '%',
    })));
const Inner = styled.div `
  position: absolute;
  inset-block-start: 0;
  inset-inline-start: 0;
  width: 100%;
  height: 100%;
`;
